import { Component } from '@angular/core';

@Component({
  selector: 'app-self-check-report',
  standalone: true,
  imports: [],
  templateUrl: './self-check-report.component.html',
  styleUrl: './self-check-report.component.scss'
})
export class SelfCheckReportComponent {

}
